<template>
  <section class="content">
    <div class="columns is-mobile">
      <div class="column is-narrow">
        <svg-icon icon="fail" class="icon is-large"/>
      </div>
      <div class="column">
        <h2 class="is-marginless">Oops</h2>
        <p><strong>Unfortunately we could not process your request.</strong><br>
        <small>Please double check your link integrity and ensure the variables are valid.</small></p>
      </div>
    </div>
  </section>
</template>

<script>
import SvgIcon from '@/components/SvgIcon'
export default {
  name: 'notfound',
  components: {
    SvgIcon
  }
}
</script>
